export const Input = {
  parts: ['field'],
  baseStyle: {
    fontFamily: 'body',
    borderRadius: '7px',
  },
  variants: {
    outline: {
      field: {
        bg: 'bg.primary',
        borderColor: 'border.primary',
        _placeholder: {
          color: 'var(--chakra-colors-text-muted) !important',
        },
        _invalid: {
          borderColor: 'error.500',
          boxShadow: '0 0 0 2px var(--chakra-colors-accent-danger)',
        },
        _focus: {
          borderColor: 'accent',
          boxShadow: '0 0 0 2px var(--chakra-colors-accent-subtle)',
          zIndex: 1,
        },
        _disabled: {
          opacity: 1,
          bg: 'var(--chakra-colors-bg-disabled) !important',
          color: 'var(--chakra-colors-text-muted) !important',
        },
      },
    },
  },
  sizes: {
    md: {
      field: {
        fontSize: ['16px', 'sm'],
        px: '2',
      },
    },
    lg: {
      field: {
        px: '4',
        h: '52px',
        fontSize: ['16px', 'sm'],
      },
    },
  },
  defaultProps: {
    variant: 'outline',
  },
};
